import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Resume from '../settings/resume.json';
import Settings from '../settings/settings.json';

const HelmetMeta = () => {
  const { basics } = Resume;
  const { colors } = Settings;

  const title = useMemo(() => `${basics.name} | ${basics.location.city} ${basics.location.country}`, [basics]);
  const description = useMemo(() => basics.description, [basics]);
  const keywords = useMemo(() => basics.keywords, [basics]);

  return (
    <Helmet>
      <meta name="theme-color" content={colors.primary} />
      <title>{title}</title>
      <meta name="author" content={basics.name} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

export { HelmetMeta };
